import { INVOICE_ACTIONS } from '@/app-constant';
import adjustInfo from './form-definition/adjust-info';
import adjustIncreaseDecrease from './form-definition/adjust-increase-decrease';
import issueReplacementInvoice from './form-definition/issue-replacement-invoice';
import cancelInvoice from './form-definition/cancel-invoice';
import copyInvoice from './form-definition/copy-invoice';
import explainInvoice from './form-definition/explain-invoice';
import issueInvoice from './form-definition/issue_invoice';

const renderHelper = {
  computed: {
    currentConfig() {
      return this.renderConfigs[this.flag] || {};
    },

    renderConfigs() {
      return {
        [INVOICE_ACTIONS.ADJUST_INFO]: {
          type: 'adjustment',
          modalTitle: this.$t('actions.form.title.adjustment-info'),
          invoiceSubTitle: this.$t('actions.form.title.invoice-adjustment-info'),
          additionalSubTitle: this.$t('actions.form.title.adjustment-info'),
          attention: '',
          notice: 'Hóa đơn điều chỉnh thông tin',
          disabledFields: ['invoice_number', 'date_created', 'currency_code', 'foreign_rate', 'note'],
        },
        [INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE]: {
          type: 'adjustment',
          invoiceSubTitle: this.$t('actions.form.title.original-invoice-info'),
          additionalSubTitle: this.$t('actions.form.title.adjustment-info'),
          attention: '',
          notice: 'Hóa đơn điều chỉnh tăng giảm',
          disabledFields: [
            'buyer_name', 'buyer_type', 'buyer_legal_name', 'buyer_taxcode', 'buyer_address', 'buyer_email', 'buyer_phone_number', 'buyer_id_no', 'mdvqhnsach', 'buyer_passport_no',
            'invoice_type', 'template_code', 'invoice_number', 'invoice_common_code', 'date_created', 'payment_method', 'currency_code', 'foreign_rate', 'note_change',
            'NBan_LDDNBo', 'NBan_PTVChuyen', 'NBan_HDSo', 'NBan_DChi', 'NBan_TNVChuyen', 'NBan_HVTNXHang',
          ],
        },
        [INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE]: {
          type: 'replacement',
          invoiceSubTitle: this.$t('actions.form.title.invoice-info'),
          additionalSubTitle: '',
          attention: 'Lưu ý: <strong>Ngày xử lý thay thế</strong> hoá đơn sẽ được làm căn cứ để tạo "Báo cáo tình hình hoá đơn", hãy chắc chắn rằng ngày thay thế cùng kỳ với ngày xuất hoá đơn để báo cáo đúng.',
          notice: 'Hóa đơn thay thế',
          disabledFields: ['invoice_type', 'template_code', 'date_created', 'invoice_number', 'agreement_date'],
        },
        [INVOICE_ACTIONS.COPY_INVOICE]: {
          type: 'copy',
          invoiceSubTitle: this.$t('actions.form.title.invoice-info'),
          additionalSubTitle: '',
          attention: '',
          notice: '',
          disabledFields: ['invoice_type', 'date_created'],
        },
        [INVOICE_ACTIONS.ISSUE_INVOICE]: {
          type: 'issue',
          invoiceSubTitle: this.$t('actions.form.title.invoice-info'),
          additionalSubTitle: '',
          attention: '',
          notice: '',
          disabledFields: ['date_created'],
        },
      };
    },

    renderFieldType() {
      return this.currentConfig.type || '';
    },
    renderInvoiceSubTitle() {
      return this.currentConfig.invoiceSubTitle || '';
    },
    renderAdditionalSubTitle() {
      return this.currentConfig.additionalSubTitle || '';
    },
    renderAttention() {
      return this.currentConfig.attention || '';
    },
    getTypeNotice() {
      return this.currentConfig.notice || '';
    },
  },

  methods: {
    isFieldDisabled(field) {
      return this.currentConfig.disabledFields.includes(field) || false;
    },
    renderForm() {
      const formConfigMap = {
        [INVOICE_ACTIONS.ADJUST_INFO]: adjustInfo,
        [INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE]: adjustIncreaseDecrease,
        [INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE]: issueReplacementInvoice,
        [INVOICE_ACTIONS.COPY_INVOICE]: copyInvoice,
        [INVOICE_ACTIONS.ISSUE_INVOICE]: issueInvoice,
        [INVOICE_ACTIONS.EXPLAIN_INVOICE]: explainInvoice,
      };
      if (!formConfigMap[this.flag]) return {};
      return formConfigMap[this.flag](this);
    },
  },
};

export default renderHelper;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/render-helper.js